import React from 'react';

import { UserInfoWrapper } from '../../components/Trainer/styled/TrainerStyled';
import packageJSON from '../../../package.json';
import { getElectronVersion } from '../../config/electron';
import { useAppSelector } from '../../store/hooks';
import { getProfileCompanyName, getProfileEmail, getProfileUserName } from '../../store/selectors/profile';
import type { RootState } from '../../store/types';

function checkMaxNameLength(stringVal: string) {
    if (stringVal.length > 27) {
        return `${stringVal.substring(0, 10)}...${stringVal.substring(stringVal.length - 10)}`;
    }
    return stringVal;
}

function getUserInfo(state: RootState) {
    const username = getProfileUserName(state) ?? getProfileEmail(state) ?? null;
    const companyName = getProfileCompanyName(state) ?? null;
    if (!username && !companyName) {
        return null;
    }
    return `${checkMaxNameLength(username ?? '')} @ ${checkMaxNameLength(companyName ?? '')}`;
}

function getVersionInfo() {
    const electronVersion = getElectronVersion();
    const coachVersion = `${packageJSON.version}`;

    return electronVersion ? `${coachVersion} [${electronVersion}]` : coachVersion;
}

function UserInfoFooter() {
    const userInfo = useAppSelector((state: RootState) => getUserInfo(state));
    const versionInfo = getVersionInfo();

    return (
        <UserInfoWrapper data-testid="trainer-user-info">
            <span>{versionInfo}</span>
            <span>{userInfo || ''}</span>
        </UserInfoWrapper>
    );
}

export default UserInfoFooter;
